// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cl-4";
export var closeButton = "_cl-6";
export var dismissButton = "_cl-3";
export var editImageWithAiContainer = "_cl-8";
export var imageUploadWrapper = "_cl-7";
export var misspelledWord = "_cl-5";
export var spellCheckContainer = "_cl-2";
export var spin = "_cl-1";
export var spinning = "_cl-0";